/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageEvacOrderHistory
 */
define(['module',
    'dojo',
    'dojo/_base/array',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/text!./templates/SignageEvacOrderHistory.html',
    'idis/service/Requester',
    'idis/view/Loader',
    '../_SignageBase',
    //'../../config',
    // 以下、変数で受けないモジュール
    'dijit/Dialog',
    'dijit/form/Form',
    'dijit/layout/BorderContainer',
    'dijit/layout/ContentPane',
    'idis/view/form/AclButton',
], function (module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase) {

    // 前回表示データ
    // セッションストレージ等に保持するほうが良いか？
    var prevItemStore = {};

    /**
     *
     * @class SignageShelterListPage
     * @extends module:idis/view/page/_PageBase~_PageBase
     */
    return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageEvacOrderHistory~SignageEvacOrderHistory# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 6,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                { 'item': 'municDisasterOccurEvacHouseholdNum', 'area': 'municDisasterOccurEvacHouseholdNumArea' },
                { 'item': 'municDisasterOccurEvaqueeNum', 'area': 'municDisasterOccurEvaqueeNumArea' },
                { 'item': 'municInstructionEvacHouseholdNum', 'area': 'municInstructionEvacHouseholdNumArea' },
                { 'item': 'municInstructionEvaqueeNum', 'area': 'municInstructionEvaqueeNumArea' },
                { 'item': 'municPreparationEvacHouseholdNum', 'area': 'municPreparationEvacHouseholdNumArea' },
                { 'item': 'municPreparationEvaqueeNum', 'area': 'municPreparationEvaqueeNumArea' },
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function () {
                this.inherited(arguments);
            },

            buildRendering: function () {
                this.inherited(arguments);
            },

            startup: function () {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function () {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function () {
                this.setEvacOrderHistoryInfo();
            },

            /**
             * 避難情報履歴を設定します
             */
            setEvacOrderHistoryInfo: function () {
                var promise = Requester.get('/data/signage/' + this._screenId + '.json', {
                    headers: { 'Content-Type': 'application/json; charset=utf-8' },
                    handleAs: 'json',
                    preventCache: true
                }).then(lang.hitch(this, function (item) {
                    // 避難情報を設定
                    var municEvacOrderInfo = item.items;
                    this.setMunicEvacOrderInfo(this, municEvacOrderInfo);
                    var evacOrderHistory = item.items.filter(function (element) {
                        return element.districtCd !== null;
                    });
                    this.setEvacOrderHistoryGrid(this, evacOrderHistory);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var municEvacOderInfo = {};
                        this.setMunicEvacOderInfo(this, municEvacOderInfo);
                        var evacOderHistory = [];
                        this.setEvacOderHistoryGrid(this, evacOderHistory);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 市町村の避難情報集計値を設定します
             */
            setMunicEvacOrderInfo: function (self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function (target) {
                    self[target.item].innerHTML = item[0][target.item].toLocaleString();
                });

                // 集計エリアのタイトルを設定
                var aggrigateAreaTitleStr = '県内合計';
                var muniItems = item.filter(function (element) {
                    return element.districtCd !== null;
                });
                if (item.length > 0) {
                    if (muniItems.length > 0 && muniItems.every(muniItem => muniItem.municipalityCd === muniItems[0].municipalityCd) && !(item[0].municipalityCd === '340006' || item[0].municipalityCd === null)) {
                        aggrigateAreaTitleStr = '市内合計（' + muniItems[0].municipalityName + '）';
                    }
                }
                self.aggrigateAreaTitle.innerHTML = aggrigateAreaTitleStr;

                // 0世帯＆0人の場合の背景色・文字色変更
                if (item[0].municDisasterOccurEvacHouseholdNum === 0 && item[0].municDisasterOccurEvaqueeNum === 0) {
                    domClass.remove(this.municDisasterOccurArea, 'occur');
                    domClass.add(this.municDisasterOccurArea, 'none');
                }
                if (item[0].municInstructionEvacHouseholdNum === 0 && item[0].municInstructionEvaqueeNum === 0) {
                    domClass.remove(this.municInstructionArea, 'oder');
                    domClass.add(this.municInstructionArea, 'none');
                }
                if (item[0].municPreparationEvacHouseholdNum === 0 && item[0].municPreparationEvaqueeNum === 0) {
                    domClass.remove(this.municPreparationArea, 'prepare');
                    domClass.add(this.municPreparationArea, 'none');
                }

                // 更新状態を設定
                this.setMunicEvacOrderInfoUpdate(self, item);
            },

            /**
             * 市町村の避難情報集計値の更新状態を設定します
             */
            setMunicEvacOrderInfoUpdate: function (self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var municEvacOrderInfo = prevItem.items[0];
                if (municEvacOrderInfo) {
                    array.forEach(this.target, function (target) {
                        // 更新された項目にstyleを設定
                        if (municEvacOrderInfo[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 避難情報履歴のグリッドを設定します
             */
            setEvacOrderHistoryGrid: function (self, data) {
                // 表示をクリア
                var evacOrderHistoryTBody = dojo.byId('evacOrderHistoryTBody');
                domConstruct.empty(evacOrderHistoryTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                if (data.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);
                }

                var prevItem = prevItemStore[this._screenId];
                var evacOrderGrid = [];
                if (prevItem) {
                    evacOrderGrid = prevItem.items.filter(function (element) {
                        return element.districtCd !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function (item) {
                    // 避難情報の前回値
                    var evacOrderGridPrevItem = null;
                    if (evacOrderGrid && evacOrderGrid.length > 0) {
                        evacOrderGridPrevItem = evacOrderGrid.filter((element) =>
                            (element.evacOrderTimestamp === item.evacOrderTimestamp) && (element.districtCd === item.districtCd)
                        )[0];
                        // 新規のデータが追加された場合は前回値を0として設定
                        if (evacOrderGridPrevItem === undefined) {
                            evacOrderGridPrevItem = {
                                "municipalityName": null, "evacOrderType": null, "districtName": null, "evacOrderTimestamp": null,
                                "issueReasonType": null, "evacHouseholdNum": null, "evaqueeNum": null
                            };
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');

                    // 市町村名
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.municipalityName !== item.municipalityName) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.municipalityName, class: className + ' align-middle text-center fw-bold first-col'
                    }), tr);

                    // 発令内容
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.evacOrderType !== item.evacOrderType) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    var evacOrderTypeConfig = self.evacOrderConfig[item.evacOrderType];
                    var evacOrderTypeLabel = [];
                    if (evacOrderTypeConfig) {
                        // 発令理由によって警戒レベルの有無を判定
                        if (self.hasWarningLevel(item)) {
                            evacOrderTypeLabel.push(`警戒レベル${evacOrderTypeConfig.level}`);
                        }
                        evacOrderTypeLabel.push(evacOrderTypeConfig.label);
                        className = className + ' ' + evacOrderTypeConfig.className;
                    } else {
                        evacOrderTypeLabel.push('解除');
                        className = className + ' cancellation';
                    }
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: evacOrderTypeLabel.join('<br>'), class: className
                    }), tr);

                    // 対象地区
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.districtName !== item.districtName) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    className = className + ' align-middle text-left';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.districtName, class: className
                    }), tr);

                    // 発令日時
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.evacOrderTimestamp !== item.evacOrderTimestamp) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.evacOrderTimestamp, class: className
                    }), tr);

                    // 発令理由
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.issueReasonType !== item.issueReasonType) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    var issueReasonTypeString = self.issueReasonTypeLabel[item.issueReasonType];
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: issueReasonTypeString, class: className
                    }), tr);

                    // 対象世帯数
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.evacHouseholdNum !== item.evacHouseholdNum) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.evacHouseholdNum.toLocaleString() + '</span>' + '世帯', class: className
                    }), tr);

                    // 対象人数
                    className = evacOrderGridPrevItem && (evacOrderGridPrevItem.evaqueeNum !== item.evaqueeNum) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.evaqueeNum.toLocaleString() + '</span>' + '人', class: className
                    }), tr);

                    domConstruct.place(tr, evacOrderHistoryTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function () {
                    self.setEvacOrderHistoryGrid(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
});
